import {createStateMaker} from '@shared/helpers/object'

import {PaginationState} from './interfaces'

export const getInitialState = (): PaginationState => ({
    type: 'WIDE',
    total: 0,
    current: 0,
    start: 0,
    end: 0,
    infinite: {
        apiStatus: 'IDLE',
    },
})

export const makeMock = createStateMaker<PaginationState>(getInitialState)
